"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterMyStack = exports.useSingleServiceData = exports.useTriggerG2Scrape = exports.useGetAllServicesNames = void 0;
var end2end_1 = require("@hudled/end2end");
var get_1 = __importDefault(require("lodash/fp/get"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var filter_1 = require("utils/filter");
var queries_1 = require("utils/firebase/queries");
var logging_1 = require("utils/logging");
var ordered_1 = require("utils/selectors/ordered");
var populated_1 = require("utils/selectors/populated");
var useGetAllServicesNames = function () {
    // useFirestoreConnect([{ collection: 'services' }]);
    var services = (0, react_redux_1.useSelector)(ordered_1.selectServices);
    return (0, react_1.useMemo)(function () { return services === null || services === void 0 ? void 0 : services.map(function (service) { return (service === null || service === void 0 ? void 0 : service.niceName) || (service === null || service === void 0 ? void 0 : service.name); }); }, [services]);
};
exports.useGetAllServicesNames = useGetAllServicesNames;
var isStaging = window.location.host.match(/staging[.-]hudled/);
var isLocalhost = window.location.host.match(/localhost/);
var useTriggerG2Scrape = function (serviceName) {
    var _a = __read((0, react_1.useState)(false), 2), isScraping = _a[0], setIsScraping = _a[1];
    var firestore = (0, react_redux_firebase_1.useFirestore)();
    var triggerG2Scrape = function () { return __awaiter(void 0, void 0, void 0, function () {
        var serviceDocID, serviceQuerySnapshot, result;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsScraping(true);
                    if (!serviceName) return [3 /*break*/, 3];
                    return [4 /*yield*/, firestore.collection('services').where('name', '==', serviceName).get()];
                case 1:
                    serviceQuerySnapshot = _c.sent();
                    serviceDocID = (_b = (_a = serviceQuerySnapshot.docs) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id;
                    if (!serviceDocID) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetch('https://api.apify.com/v2/acts/hudled~hudled-g2-scrape/runs?token=uL4sdN9fsSSJkGqKvnQHE2pn4', {
                            method: 'POST',
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                services: [{ name: serviceName, id: serviceDocID }],
                                env: (isStaging || isLocalhost) ? 'staging' : 'prod',
                            }),
                        })];
                case 2:
                    result = _c.sent();
                    if (result.status === 201) {
                        (0, logging_1.logInfo)('Apify cloud scraping is starting');
                        setIsScraping(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setIsScraping(false);
                    _c.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return [triggerG2Scrape, isScraping];
};
exports.useTriggerG2Scrape = useTriggerG2Scrape;
var useSingleServiceData = function (serviceStat, dateRange, exclusions) {
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        !(exclusions === null || exclusions === void 0 ? void 0 : exclusions.transactions) && (0, queries_1.transactionsForServiceStatQuery)(serviceStat, dateRange),
        !(exclusions === null || exclusions === void 0 ? void 0 : exclusions.recommendations) && (0, queries_1.recommendationsForServiceQuery)(serviceStat),
        !(exclusions === null || exclusions === void 0 ? void 0 : exclusions.reviews) && (0, queries_1.reviewsForServiceQuery)(serviceStat),
        !(exclusions === null || exclusions === void 0 ? void 0 : exclusions.otherTools) && (0, queries_1.serviceComparisonsQuery)(__assign(__assign({}, serviceStat.service), { id: serviceStat.serviceId })),
    ].filter(end2end_1.notFalsy); });
    var _a = __read(react_1.default.useMemo(function () { return [
        (0, ordered_1.makeSelectRecommendationsForService)(serviceStat === null || serviceStat === void 0 ? void 0 : serviceStat.serviceId),
        (0, populated_1.makeSelectServiceReviews)(serviceStat === null || serviceStat === void 0 ? void 0 : serviceStat.serviceId),
        (0, ordered_1.makeSelectTransactionsForService)(serviceStat === null || serviceStat === void 0 ? void 0 : serviceStat.serviceId),
        (0, ordered_1.makeSelectServiceComparisons)(serviceStat === null || serviceStat === void 0 ? void 0 : serviceStat.serviceId),
    ]; }, [serviceStat === null || serviceStat === void 0 ? void 0 : serviceStat.serviceId]), 4), selectRecommendationsForService = _a[0], selectServiceReviews = _a[1], selectTransactionsForService = _a[2], selectComparisonsForService = _a[3];
    var recommendations = (0, react_redux_1.useSelector)(selectRecommendationsForService);
    var reviews = (0, react_redux_1.useSelector)(selectServiceReviews);
    var transactions = (0, react_redux_1.useSelector)(selectTransactionsForService);
    var otherTools = (0, react_redux_1.useSelector)(selectComparisonsForService);
    return {
        recommendations: recommendations,
        reviews: reviews,
        transactions: transactions,
        otherTools: otherTools,
    };
};
exports.useSingleServiceData = useSingleServiceData;
var useFilterMyStack = function (sStatsList) { return (0, filter_1.useFilterItems)(sStatsList, [(0, get_1.default)('service.name'), (0, get_1.default)('service.niceName'), function (item) { return (0, end2end_1.getDisplayName)(item.owner); }], [filter_1.toolGroupCheck, filter_1.ownersCheck, filter_1.teamsCheck]); };
exports.useFilterMyStack = useFilterMyStack;
// export const useDebouncedSetSearch = () => {
//   const [searchText, setSearchText] = React.useState(null);
//   const [searchTextDebounced, setSearchTextDebounced] = React.useState(null);
//   const debouncedSetSearchTextDebounced = React.useCallback(debounce(setSearchTextDebounced, 100), []);
//
//   return [
//     searchText,
//     (txt: string) => {
//       setSearchText(txt);
//       debouncedSetSearchTextDebounced(txt);
//     },
//     searchTextDebounced,
//   ];
// };
